import { supabaseClient } from "@/lib/supabase";
import { queryOptions, useQuery } from "@tanstack/react-query";

export async function selectSurgeryById(surgeryId: string) {
    const { data, error } = await supabaseClient
        .from("surgery_options")
        .select("*")
        .eq("surgery_option_id", surgeryId).single();
    if (error) throw error;
    return data;
}

export const surgeryByIdQueryKey = ["surgery_by_id"];

export const selectSurgeryByIdQueryOptions = (surgeryId: string) => {
    return queryOptions({
        queryKey: surgeryByIdQueryKey,
        queryFn: () => selectSurgeryById(surgeryId),
    });
};

export function useSelectSurgeryById(surgeryId: string) {
    const surgeryByIdQuery = useQuery(selectSurgeryByIdQueryOptions(surgeryId));
    return surgeryByIdQuery;
}

export function useSurgeryById(surgeryId: string) {
    return useSelectSurgeryById(surgeryId);
}
